import translateUtils from '../../../_helpers/translateUtils'

const Boolean = (path) => (rowData) =>
  rowData[path]
    ? translateUtils.translate('Yes')
    : translateUtils.translate('No')

export default Boolean
